import { render, staticRenderFns } from "./TeamWorkshiftPlanDetails.vue?vue&type=template&id=0cb88022&scoped=true"
import script from "./TeamWorkshiftPlanDetails.vue?vue&type=script&lang=js"
export * from "./TeamWorkshiftPlanDetails.vue?vue&type=script&lang=js"
import style0 from "./TeamWorkshiftPlanDetails.vue?vue&type=style&index=0&id=0cb88022&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb88022",
  null
  
)

export default component.exports